import React from 'react';

import { string, shape, oneOfType, node, arrayOf } from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../../BaseComponent';

import './ListItem.scss';

export default class ListItem extends BaseComponent {
  render() {
    const { children, id, style, className, onClick } = this.props;

    const classes = ['ListItem', className];

    const classNames = ClassNames(classes);

    return (
      <li id={id} style={style} className={classNames}>
        <button type="button" className="ListItem-inner" onClick={onClick}>
          {children}
        </button>
      </li>
    );
  }
}

ListItem.propTypes = {
  id: string,
  style: shape({}),
  className: string,
  children: oneOfType([arrayOf(node), node]).isRequired
};

ListItem.defaultProps = {
  id: undefined,
  style: {},
  className: undefined
};
